import React from "react";
import classes from "./Shared.module.scss";

const email = (props) => {
  return (
    <a className={[classes.Email, classes[props.where]].join(' ')} href="mailto:ecfoundationfl@gmail.com">ecfoundationfl@gmail.com</a>
  );
}
export default email;